import { useScrollToTopDependencies } from "../components/ScrollToTopContextProvider";
import { useOnChange } from "./useOnChange";
/**
 * Scrolls the given target to top if the dependency list of the
 * ScrollToTopContextProvider changes
 */
export const useScrollToTop = (target) => {
    const scrollTopDependencies = useScrollToTopDependencies() ?? [];
    useOnChange(() => {
        if (target) {
            target.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    }, scrollTopDependencies);
};
export default useScrollToTop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU2Nyb2xsVG9Ub3AuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlU2Nyb2xsVG9Ub3AudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLDBCQUEwQixFQUFFLE1BQU0sMENBQTBDLENBQUM7QUFDdEYsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUU1Qzs7O0dBR0c7QUFDSCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsQ0FDNUIsTUFBK0MsRUFDekMsRUFBRTtJQUNSLE1BQU0scUJBQXFCLEdBQUcsMEJBQTBCLEVBQUUsSUFBSSxFQUFFLENBQUM7SUFFakUsV0FBVyxDQUFDLEdBQUcsRUFBRTtRQUNmLElBQUksTUFBTSxFQUFFLENBQUM7WUFDWCxNQUFNLENBQUMsUUFBUSxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUUsQ0FBQyxDQUFDO1FBQzNELENBQUM7SUFDSCxDQUFDLEVBQUUscUJBQXFCLENBQUMsQ0FBQztBQUM1QixDQUFDLENBQUM7QUFFRixlQUFlLGNBQWMsQ0FBQyJ9